/* eslint-disable no-magic-numbers */
import {
  GET_EVENTS,
  GET_EVENTS_SUCCESS,
  GET_EVENTS_FAILURE,
  LIVE_UPDATES,
  LIVE_LINES_UPDATES,
  GET_LINES_SUCCESS,
  FETCH_FUTURE_EVENT_INFO,
  FETCH_FUTURE_EVENT_SUCCESS,
  FETCH_FUTURE_EVENT_FAILURE,
} from 'constants/actionTypes'

import { updateLines } from '@advisiondevelopment/data-formatter'

import {
  currentLinesUpdater,
  eventsUpdater,
  scoresUpdater,
  parserEvents,
  getLinesUpdater,
  getHigherMaxSequence,
} from 'helpers/events'
import { setLiveUpdates } from 'helpers/reducer'

const updaters = {
  currentLines: currentLinesUpdater,
  events: eventsUpdater,
  scores: scoresUpdater,
}

const initialState = { events: {}, lines: { currentLines: [] } }

const handlers = {
  [GET_EVENTS]: (state) => ({ ...state, isFetching: true }),
  [GET_EVENTS_FAILURE]: (state) => ({ ...state, isFetching: false }),
  [GET_EVENTS_SUCCESS]: (state, { payload }) => ({
    ...state,
    events: parserEvents(payload.events, [3], payload.leagueSlugFromConfig),
    maxSequences: payload.maxSequences,
    isFetching: false,
  }),
  [GET_LINES_SUCCESS]: (state, { payload }) => {
    const { currentLines, consensus, consensusV2, openingLines, bestLines } =
      payload || {}

    return {
      ...state,
      isFetching: false,
      maxSequences: {
        ...state.maxSequences,
        currentLines: { maxSequence: getHigherMaxSequence(currentLines) },
      },
      lines: payload,
      events: getLinesUpdater({
        events: state.events,
        currentLines,
        openingLines,
        bestLines,
        consensus,
        consensusV2,
      }),
    }
  },
  [LIVE_LINES_UPDATES]: (state, { payload }) => {
    const {
      currentLines = [],
      consensus = [],
      consensusV2 = [],
      openingLines = [],
      bestLines = [],
    } = payload || {}

    const currentLinesUpdated = updateLines(
      currentLines,
      state.lines.currentLines || [],
    )
    const consensusLinesUpdated = updateLines(
      consensus,
      state.lines.consensus || [],
    )
    const consensusV2LinesUpdated = updateLines(
      consensusV2,
      state.lines.consensusV2 || [],
    )
    const openingLinesLinesUpdated = updateLines(
      openingLines,
      state.lines.openingLines || [],
    )
    const bestLinesLinesUpdated = updateLines(
      bestLines,
      state.lines.bestLines || [],
    )

    return {
      ...state,
      lines: {
        currentLines: currentLinesUpdated,
        consensus: consensusLinesUpdated,
        consensusV2: consensusV2LinesUpdated,
        openingLines: openingLinesLinesUpdated,
        bestLines: bestLinesLinesUpdated,
      },
      events: getLinesUpdater({
        events: state.events,
        currentLines: currentLinesUpdated,
        openingLines: openingLinesLinesUpdated,
        bestLines: bestLinesLinesUpdated,
        consensus: consensusLinesUpdated,
        consensusV2: consensusV2LinesUpdated,
      }),
    }
  },
  [LIVE_UPDATES]: (state, { payload }) => {
    const { events: eventsUpdates } = payload.updates || {}
    const updatedEvents = setLiveUpdates(updaters, state.events, payload)

    if (!eventsUpdates || !eventsUpdates.length) {
      return { ...state, events: updatedEvents }
    }

    return { ...state, events: updatedEvents }
  },
  [FETCH_FUTURE_EVENT_INFO]: (state) => ({ ...state, isFetching: true }),
  [FETCH_FUTURE_EVENT_FAILURE]: (state) => ({ ...state, isFetching: false }),
  [FETCH_FUTURE_EVENT_SUCCESS]: (state, { payload }) => ({
    ...state,
    events: payload.futureEventInfo,
    isFetching: false,
  }),
}

export default function events(state = initialState, action) {
  const { type } = action

  return handlers[type] ? handlers[type](state, action) : state
}
